<div class="container-fluid">
  <div class="card">
    <div class="title">
      <div>위치기반 서비스 이용약관</div>
    </div>
    <div class="card-body top" *ngIf="location">
      <div class="content">{{ location }}</div>
    </div>
  </div>
</div>
